import { Injectable } from "@angular/core";
import { BaseLookupService } from "../../impl/BaseLookupService";
import { IOpsIntLookupService } from "../IOpsIntLookupService";
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Injectable()
export class OpsIntLookupService
  extends BaseLookupService<string, CubiqTS.OpsIntEventImpl>
  implements IOpsIntLookupService
{
  private _opsFiltCategoryIdMap = new Map<CubiqTS.OpsExceptionType, string>();
  private _opsFiltCategoryDescMap = new Map<CubiqTS.OpsExceptionType, string>();
  private _opsFiltCategoryTypes = new Map<string, CubiqTS.OpsFiltCategoryType>();

  constructor() {
    super(CubiqTS.OpsIntEventImpl);
  }

  getItemKey(item: CubiqTS.OpsIntEventImpl): string {
    let opsEvent = item as CubiqTS.OpsIntEventImpl;
    return opsEvent.eventId.toString();
  }

  hasOpsInt(id: string): boolean {
    return this.myItemMap.has(id);
  }

  getOpsInt(id: string): CubiqTS.OpsIntEventImpl {
    let opsData = this.getItem(id) as CubiqTS.OpsIntEventImpl;
    if (opsData) {
      opsData = Object.assign(new CubiqTS.OpsIntEventImpl(), opsData);
    }
    return opsData;
  }

  mapItem(item: CubiqTS.OpsIntEventImpl): void {
    super.mapItem(item);
  }

  primeOpsFilterCompositeDate(data: CubiqTS.OpsFilterCompositeDataImpl): void {
    if (data != null && Array.isArray(data.opsFilterCategoryTypes)) {
      data.opsFilterCategoryTypes.forEach((value) => {
        if (value != null && value instanceof CubiqTS.OpsFiltCategoryTypeImpl) {
          this._opsFiltCategoryTypes.set(value.filterCategoryId, value);
        }
      });
    }

    if (data != null && Array.isArray(data.opsFilterCategories)) {
      data.opsFilterCategories.forEach((value) => {
        if (value != null && value instanceof CubiqTS.OpsFiltCategoryImpl) {
          this._opsFiltCategoryIdMap.set(value.opsExceptionType, value.filterCategoryId);

          this._opsFiltCategoryDescMap.set(
            value.opsExceptionType,
            this._opsFiltCategoryTypes.get(value.filterCategoryId).filterCatDesc,
          );
        }
      });
    }
  }

  getCategoryIdByExceptionTypeId(exceptionTypeId: CubiqTS.OpsExceptionType): string {
    let categoryId = this._opsFiltCategoryIdMap.get(exceptionTypeId);
    return categoryId;
  }

  getCategoryDescByExceptionTypeId(exceptionTypeId: CubiqTS.OpsExceptionType): string {
    let categoryDesc = this._opsFiltCategoryDescMap.get(exceptionTypeId);
    return categoryDesc;
  }

  getCategoryTypes(): Map<string, CubiqTS.OpsFiltCategoryType> {
    return new Map(this._opsFiltCategoryTypes);
  }
}
